import type { PipeTransform } from '@angular/core';
import { Pipe, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'safeHtml',
  standalone: true,
})
export class SafeHTMlPipe implements PipeTransform {
  public constructor(private readonly domSanitizer: DomSanitizer) {}

  public transform(value?: string | null): SafeHtml {
    if (!value) {
      return '';
    }

    const cleanHTML = this.domSanitizer.sanitize(SecurityContext.HTML, value);
    if (cleanHTML === null) {
      return '';
    }

    return this.domSanitizer.bypassSecurityTrustHtml(cleanHTML);
  }
}
